import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LoadingScreen } from "@/vendor/chat-shell";
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") {
    return <LoadingScreen label="Checking sign-in…" layout={location.pathname.startsWith("/chat") ? "chat" : "page"} />;
  }
  if (status !== "authenticated") {
    return <Navigate to={`/signup?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  return children;
}
